import { HtmlParser } from "~/components/HtmlParser";
import { Image } from "~/components/ui/image";
import { cn } from "~/utils/classnames";

import type { CmsBlockProps } from "./CmsBlock.types";

export const CmsBlock = ({ cmsParagraph, className, ...props }: CmsBlockProps) => {
  return (
    <div
      className={cn(
        "mb-12 flex flex-col text-grey-900 sm:flex-row sm:items-start sm:gap-10 md:items-center",
        className
      )}
      {...props}
    >
      {cmsParagraph.image ? (
        <Image
          className="shrink-1 w-64 grow-0 basis-64 rounded-2xl object-cover"
          src={cmsParagraph.image}
          alt={cmsParagraph.label}
        />
      ) : null}

      <HtmlParser html={cmsParagraph.content} className="grow-1 shrink-1 mt-6 sm:mt-0" />
    </div>
  );
};
